import { render, staticRenderFns } from "./indexGis.vue?vue&type=template&id=54033a42&scoped=true"
import script from "./indexGis.vue?vue&type=script&lang=js"
export * from "./indexGis.vue?vue&type=script&lang=js"
import style0 from "./indexGis.vue?vue&type=style&index=0&id=54033a42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54033a42",
  null
  
)

export default component.exports